import React from 'react';
import { Tooltip } from 'react-tooltip';

const hasEngagementScore = (engagementScore) =>
  engagementScore !== null &&
  engagementScore !== undefined &&
  engagementScore !== false;

const getColor = (completed, engagementScore, isCurrent) => {
  if (isCurrent) {
    return 'bg-[#dff7ff] text-black';
  }

  if (!completed || engagementScore === false) return 'bg-white text-black';
  if (engagementScore >= 60) return 'bg-light-blue text-white';
  return 'bg-yellow text-black';
};

const Beads = ({ statusArr, uniqueId }) => {
  const tooltipId = `engagement-tooltip-${uniqueId}`;
  const currentModuleIndex = statusArr.findIndex(
    (status) =>
      !status.dateCompleted && hasEngagementScore(status.engagementScore),
  );

  return (
    <div className='relative flex items-start gap-2 w-[500px]'>
      <div className='absolute left-[5%] right-[5%] top-5 h-[6px] bg-blue-800 -translate-y-1/2 z-0' />

      {statusArr.map((status, index) => {
        const completed = Boolean(status.dateCompleted);
        const isCurrent = index === currentModuleIndex;
        const completedDate = completed
          ? new Date(status.dateCompleted).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })
          : 'not completed';

        const engagement = status.engagementScore;
        const colorClass = getColor(completed, engagement, isCurrent);
        const labelClass = isCurrent ? 'text-light-blue' : 'text-black';
        const beadKey = `${uniqueId}-${index}`;

        return (
          <div key={beadKey} className='flex flex-col items-center gap-2 w-20'>
            {completed ? (
              <button
                type='button'
                data-tooltip-id={tooltipId}
                data-tooltip-content={`Engagement Index ${engagement}%`}
                data-tooltip-place='top'
                className={`${colorClass} relative z-20 aspect-square w-10 border-4 border-dark-blue rounded-full p-1 flex items-center justify-center`}
              >
                <span className='text-base font-bold'>{index + 1}</span>
              </button>
            ) : (
              <div
                className={`${colorClass} relative z-20 aspect-square w-10 border-4 border-dark-blue rounded-full p-1 flex items-center justify-center`}
              >
                <span className='text-base font-bold'>{index + 1}</span>
              </div>
            )}

            {completed ? (
              <div className='text-sm font-bold text-center text-black'>
                {completedDate}
              </div>
            ) : (
              <div
                className={`text-sm font-bold text-center leading-tight ${labelClass}`}
              >
                {isCurrent ? (
                  <>
                    <span className='block'>In</span>
                    <span className='block'>Progress</span>
                  </>
                ) : (
                  <>
                    <span className='block'>Not</span>
                    <span className='block'>Completed</span>
                  </>
                )}
              </div>
            )}
          </div>
        );
      })}

      <Tooltip
        id={tooltipId}
        positionStrategy='fixed'
        style={{ zIndex: 9999 }}
      />
    </div>
  );
};

export default Beads;
